import { Box, Flex, Text } from '@chakra-ui/react';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { HubsSortDropdown } from '@/components/ui/shared/hubs/HubsPageActions/components/HubsSortDropdown';
import { IOptionItem } from '@/components/ui/shared/hubs/HubsPageActions/components/types';
import { HubTagFilters } from '@/components/ui/shared/tags/HubTagFilters/HubTagFilters';

interface IHubsPageActionsProps {
  sortingOptions: Array<IOptionItem>;
  defaultOption: string;
  totalCount: number;
}

export const HubsPageActions: FC<IHubsPageActionsProps> = ({ sortingOptions, defaultOption, totalCount }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Flex
        mt={{ base: 4, md: 6 }}
        direction={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'flex-end', md: 'center' }}
        justifyContent="space-between"
        gap={4}
      >
        <Text color="gray.800" textAlign="right" textStyle="plexBody">
          <Text as="span" fontSize="md" fontWeight="bold" fontFamily="heading">
            {totalCount}
          </Text>{' '}
          <Text as="span" fontSize="sm">
            {t('common.results')}
          </Text>
        </Text>
        <Box>
          <HubsSortDropdown options={sortingOptions} defaultOption={defaultOption} />
        </Box>
      </Flex>
      <HubTagFilters display={{ base: 'none', sm: 'flex' }} />
    </Fragment>
  );
};
